import { Box, Typography, Button, Container, Paper, HomeOutlinedIcon, ArrowBackIcon } from 'src/components';
import { useNavigate } from 'react-router-dom';

function PageNotFound() {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/');
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '80vh',
                    textAlign: 'center',
                }}
            >
                <Paper
                    elevation={0}
                    sx={{
                        p: 4,
                        borderRadius: 3,
                        width: '100%',
                        maxWidth: 400,
                    }}
                >
                    {/* 404 Number */}
                    <Typography
                        variant="h1"
                        sx={{
                            fontSize: { xs: '6rem', sm: '8rem' },
                            fontWeight: 'bold',
                            color: 'primary.main',
                            lineHeight: 1,
                            mb: 1,
                        }}
                    >
                        404
                    </Typography>

                    {/* Main heading */}
                    <Typography
                        variant="h4"
                        component="h1"
                        gutterBottom
                        sx={{
                            fontWeight: 600,
                            mb: 2,
                        }}
                    >
                        Page Not Found
                    </Typography>

                    {/* Description */}
                    <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{ mb: 4, lineHeight: 1.6 }}
                    >
                        Oops! The page you're looking for seems to have wandered off. 
                        It might have been moved, deleted, or you entered the wrong URL.
                    </Typography>

                    {/* Action buttons */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: 2,
                            justifyContent: 'center',
                        }}
                    >
                        <Button
                            variant="contained"
                            startIcon={<HomeOutlinedIcon />}
                            onClick={handleGoHome}
                            size="large"
                            sx={{ minWidth: 120 }}
                        >
                            Go Home
                        </Button>

                        <Button
                            variant="outlined"
                            startIcon={<ArrowBackIcon />}
                            onClick={handleGoBack}
                            size="large"
                            sx={{ minWidth: 120 }}
                        >
                            Go Back
                        </Button>
                    </Box>
                </Paper>
            </Box>
        </Container>
    );
}

export default PageNotFound;